import ItemPrice from "../../molecules/ItemPrice";
import {AddToCartButton} from "../../cart/AddToCartButton/AddToCartButtonPortal";
import AddToWishlistButton from "../../wishlist/AddToWishlistButton/AddToWishlistButton";
import React from "react";
import {LookItemType} from "./LookTypes";
import {useTranslation} from "react-i18next";

const DesktopPopup: React.FC<{product: LookItemType; handleClose: () => void; isActive: boolean}> = ({
  product,
  handleClose,
  isActive,
}) => {
  const {t} = useTranslation();
  const calcTooltipTopPos = product.coordinates.y + 3;
  const tooltipTopPos = calcTooltipTopPos < 50 ? calcTooltipTopPos : 50; // place very low positioned tooltips at 50% to prevent unwanted cut-offs

  return (
    <div
      className="tooltip"
      style={{
        display: isActive ? undefined : "none",
        left: `${product.coordinates.x + 3}%`,
        top: `${tooltipTopPos}%`,
      }}
    >
      <button className="tooltip-close" onClick={handleClose}>
        ×
      </button>
      <div className="tooltip-content">
        {/* Item URL später anpassen */}
        <a href={product.item.url}>
          <img
            src={product.imgUrl1x}
            srcSet={`${product.imgUrl1x ?? ""} 1x, ${product.imgUrl2x ?? ""} 2x`}
            className="tooltip-image"
            alt={product.item.title}
          />
        </a>
        <div className="tooltip-info">
          {product.isAlternative && <div className="similar-product">{t("shopthelook.similarProduct")}</div>}
          <div className="tooltip-brand">{product.item.manufacturer}</div>
          <div className="tooltip-title">{product.itemName}</div>
          <div className="tooltip-price">
            <ItemPrice
              images={product.item.images}
              itemAttributes={product.item.attributes}
              prices={product.item.prices}
            />
          </div>
        </div>
      </div>
      <div className="button-group">
        <AddToCartButton itemId={product.item.itemId} />
        <AddToWishlistButton itemId={product.item.itemId} customClass="heart-button" size="small" />
      </div>
    </div>
  );
};

export default DesktopPopup;
